var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { MixpanelService } from './../mixpanel/mixpanel.service';
import { CurrentOrderService } from './currentOrder.service';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { OrderValidation } from './orderValidation';
import { TranslateService } from '@ngx-translate/core';
var OrderComponent = (function () {
    //private validClass: string = 'fa fa-check';
    function OrderComponent(titleService, translate, currentOrderService, _orderValidation, mixpanelService) {
        var _this = this;
        this.titleService = titleService;
        this.translate = translate;
        this.currentOrderService = currentOrderService;
        this._orderValidation = _orderValidation;
        this.mixpanelService = mixpanelService;
        this.currentOrderService.order.subscribe(function (order) { return _this.order = order; });
        this.currentOrderService.orderMenuVisibility.subscribe(function (menu) { return _this.orderMenuVisibility = menu; });
        this.currentOrderService.orderType.subscribe(function (orderType) { return _this.orderType = orderType; });
        this.orderValidation = this._orderValidation;
        this.titleService.setTitle("Order | Uptime");
        this.translate.get('ORDER.ORDER_UPPERCASE').subscribe(function (value) {
            _this.currentOrderService.setOrderType({
                uppercaseType: "Order",
                uppercaseLabel: value
            });
        });
        this.translate.get('ORDER.ORDER_LOWERCASE').subscribe(function (value) {
            _this.currentOrderService.setOrderType({
                lowercaseType: "order",
                lowercaseLabel: value
            });
        });
    }
    OrderComponent.prototype.ngOnInit = function () {
        this.mixpanelService.api.people.set_once({
            "number_of_request": 0
        });
    };
    OrderComponent = __decorate([
        Component({
            selector: 'cx-order',
            templateUrl: './order.component.html',
        }),
        __metadata("design:paramtypes", [Title,
            TranslateService,
            CurrentOrderService,
            OrderValidation,
            MixpanelService])
    ], OrderComponent);
    return OrderComponent;
}());
export { OrderComponent };
//# sourceMappingURL=order.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/order.component.js
// module id = 187
// module chunks = 0